import { useContext, useState } from "react";
import "./main-page.css";
import ProductInfoCard from "../ui/productInfoCard";
import { cartContext } from "../../App";
import BottomCart from "../ui/bottom-cart";
import { Link } from "react-router-dom";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import HeaderMain from "../ui/headerMain";
import LoginPopUp from "../subcomponents/login-popup";
import CategoryMenu from "../subcomponents/category-menu";
import { category } from "../utility/category";
import RequestProductCTA from "../ui/request-product-cta";

export default function MainPage() {
 
    const [showPopup, setShowPopup] = useState(false);
    const { productDataList, extraData, maxAmountReached, deferredPrompt, showDownloadButton, changeInstallVariable } = useContext(cartContext);
    const categoryList = category;
    const hasCategoryList = Array.isArray(categoryList) && categoryList.length > 0;

    const homeOfficeData = [];
    const cleaningEssentialsData = [];
    const personalCareData = [];
    const dryFruitsNutsData = [];
    const stationaryData = [];
    const fruitsVegetablesData = [];
    const electronicsData = [];
    const gadgetsData = [];
    const poojaData = [];
    const snacksDrinksData = [];
    const min50Discount = [];

    const poojaNeedsProductGroupId = 'pooja-needs';
    const electronics = {
        primaryCategoryId: 'household-essentials',
        subCategoryId: 'electronics',
        data: {}
    };
    const stationaryCategory = {
        primaryCategoryId: 'household-essentials',
        subCategoryId: 'stationary-games',
        data: {}
    };
    const cleaningEssentials = {
        primaryCategoryId: 'household-essentials',
        subCategoryId: 'cleaning-essentials',
        data: {}
    };
    const skinFaceCare = {
        primaryCategoryId: 'beauty-personal-care',
        subCategoryId: 'skin-face-care',
        data: {}
    };
    const drinksJuices = {
        primaryCategoryId: 'snacks-drinks',
        subCategoryId: 'drinks-juices',
        data: {}
    };
    const fruitsVegetables = {
        primaryCategoryId: 'grocery',
        subCategoryId: 'vegetables-fruits',
        data: {}
    };
    const snacksDrinks = {
        primaryCategoryId: 'snacks-drinks',
        subCategoryId: 'chips-namkeen',
        data: {}
    };

    if (hasCategoryList) {
        categoryList.forEach((primary_cat) => {
            primary_cat.data?.forEach((subCat) => {
                if (primary_cat.id === electronics.primaryCategoryId && subCat.id === electronics.subCategoryId) {
                    electronics.data = subCat;
                }
                if (primary_cat.id === stationaryCategory.primaryCategoryId && subCat.id === stationaryCategory.subCategoryId) {
                    stationaryCategory.data = subCat;
                }
                if (primary_cat.id === cleaningEssentials.primaryCategoryId && subCat.id === cleaningEssentials.subCategoryId) {
                    cleaningEssentials.data = subCat;
                }
                if (primary_cat.id === skinFaceCare.primaryCategoryId && subCat.id === skinFaceCare.subCategoryId) {
                    skinFaceCare.data = subCat;
                }
                if (primary_cat.id === drinksJuices.primaryCategoryId && subCat.id === drinksJuices.subCategoryId) {
                    drinksJuices.data = subCat;
                }
                if (primary_cat.id === fruitsVegetables.primaryCategoryId && subCat.id === fruitsVegetables.subCategoryId) {
                    fruitsVegetables.data = subCat;
                }
                if (primary_cat.id === snacksDrinks.primaryCategoryId && subCat.id === snacksDrinks.subCategoryId) {
                    snacksDrinks.data = subCat;
                }

            });
        });
    }

    productDataList.forEach((item) => {
        const category = item.data.category || '';
        const subcategoryId = item.data.subcategoryId || '';
        const productGroupId = item.data.productGroupId || '';

        if (extraData.data.categories?.['home']?.includes(category)) {
            homeOfficeData.push(item);
        } else if (cleaningEssentials.subCategoryId && subcategoryId === cleaningEssentials.subCategoryId) {
            cleaningEssentialsData.push(item);
        } else if (skinFaceCare.subCategoryId && subcategoryId === skinFaceCare.subCategoryId) {
            personalCareData.push(item);
        } else if (extraData.data.categories?.['dry-fruits-nuts']?.includes(category)) {
            dryFruitsNutsData.push(item);
        } else if (stationaryCategory.subCategoryId && subcategoryId === stationaryCategory.subCategoryId) {
            stationaryData.push(item);
        } else if (fruitsVegetables.subCategoryId && subcategoryId === fruitsVegetables.subCategoryId) {
            fruitsVegetablesData.push(item);
        } else if (electronics.subCategoryId && subcategoryId === electronics.subCategoryId) {
            electronicsData.push(item);
        } else if (extraData.data.categories?.['snacks-drinks']?.includes(category)) {
            snacksDrinksData.push(item);
        }

        if (category === 'gadgets' && gadgetsData.length < 10) {
            gadgetsData.push(item);
        }
        if (productGroupId === poojaNeedsProductGroupId) {
            poojaData.push(item);
        }
        if (item.data.discount && Number(item.data.discount) >= 50) {
            min50Discount.push(item);
        }
    });

    const settings = {
        dots: false, // Show navigation dots
        infinite: extraData.data.images.length > 1, // Infinite looping
        speed: 500, // Transition speed
        slidesToShow: Math.min(extraData.data.images.length, 1), // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll
        autoplay: true, // Auto-slide
        autoplaySpeed: 10000, // Auto-slide speed in ms
        arrows: true, // Show navigation arrows
    };

    // const handleAddToHomeScreen = () => {
    //     if (deferredPrompt) {
    //       deferredPrompt.prompt();
    //       deferredPrompt.userChoice.then((choiceResult) => {
    //         if (choiceResult.outcome === 'accepted') {
    //           console.log('User added the app to their home screen');
    //         } else {
    //           console.log('User dismissed the prompt');
    //         }
    //           changeInstallVariable();
    //       });
    //     }
    // };

    setTimeout(() => {
        setShowPopup(true);
    }, 4000)
    
    return (
        <>
            {
                maxAmountReached && (
                    <div className="max-amount-reached">
                        <p className="max-amount-reached-text">Maximum Quantity Reached!</p>
                    </div>
                )
            }
            <HeaderMain />
            { showPopup && <LoginPopUp />}
            {/* <div style={{ display:'flex', justifyContent:'center'}}>
                <div className="poster">
                    <Slider {...settings}>
                        {
                            extraData.data.images.map((image, index) => (
                                <img key={ index } className='poster-img' src={ image }/>
                            ))
                        }
                    </Slider>
                    
                </div>
            </div> */}

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Fresh Fruits & Vegetables</p>
                    <Link to='/display-products' state={{name:'Fresh Fruits & Vegetables', productList: fruitsVegetablesData}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={fruitsVegetablesData} />
                </div>
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Snacks & Drinks</p>
                    <Link to='/display-products' state={{name:'Snacks & Drinks', productList: snacksDrinksData}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={snacksDrinksData} />
                </div>
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Limited Time Deal – Min. 50% OFF!</p>
                    <Link to='/display-products' state={{name:'Flash Deals — 50% OFF', productList: min50Discount}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={min50Discount} />
                </div>
            </div>

            {/* color used  background #E3FFE5 */}
            <p className="tag-name" style={{marginLeft:'15px'}}>Shop By Category</p>
            <CategoryMenu />

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Personal Care</p>
                    <Link to='/display-products' state={{name:'Personal Care', productList: personalCareData}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={personalCareData} />
                </div>
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Daily Pooja Essentials</p>
                    <Link to='/display-products' state={{category:'', name:'Daily Pooja Essentials', productList: poojaData}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={poojaData} />
                </div>
            </div>

            <p style={{fontSize:'16px', fontWeight:'bold', marginLeft:'20px'}}>Featured</p>
            <div className="color-adv-box">
                <Link to='/display-products-category'
                    state={{
                        name: 'Snacks & Munchies',
                        categoryData: snacksDrinks.data
                    }}
                >
                    <div>
                        <img src="/adv-img/snacks-featured-4754.jpg" style={{width:'120px', borderRadius:'10px'}}/>
                    </div>
                </Link>
                <Link to='/display-products' state={{ category: 'face-wash', name: 'Face Washes' }}>
                    <div>
                        <img src="/adv-img/facewash.jpg" style={{width:'120px', borderRadius:'10px'}}/>
                    </div>
                </Link>
                <Link to='/display-products' state={{ category: 'perfume', name: 'Fragrances' }}>
                    <div>
                        <img src="/adv-img/fragrance.jpg" style={{width:'120px', borderRadius:'10px'}}/>
                    </div>
                </Link>    
            </div>

            <div className="horizonatal-scroll" style={{backgroundColor:'rgb(207, 239, 190)', width:'100%', margin:'5px 0 0 0', padding:'0 0 5px 0'}}>
                <div className="name-see-all" >
                    <p className="tag-name" style={{display:'flex', alignItems:'center', fontSize:'18px', marginLeft:'15px'}}>For Students</p>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                        {/* <img src="/students2.png" style={{ height: '100px'}}></img> 
                        <img src="/student.png" style={{ height: '100px' }}></img>                         */}
                        <img src="/adv-img/student-grp.png" style={{ height: '110px' }}></img>                        
                    </div>

                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={stationaryData} />
                </div>
            </div>
            <Link to='/display-products-category'
                state={{
                    name: 'Stationary',
                    categoryData: stationaryCategory.data
                    
                }}
                style={{ textDecoration: 'none' }}>
                <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', padding:'10px 10px', background:'#2c5f2d' }}>
                    <p className="see-all" style={{ color:'white', fontSize:'16px' }}>See All Products</p>  
                    <p style={{color:'white'}}>&#62;</p>
                </div>
            </Link>
            {/* <Link to='/display-products-category'
                state={{
                    category: 'chips-namkeen,biscuits-cookies,sweets-chocolates,drinks-juices',
                    name: 'Snacks & Munchies',
                    categoryName:'Chips & Namkeen,Biscuits & Cookies,Sweets & Chocolates,Drinks & Juices'
                }}
            >
                <div>
                    <img src="/adv-img/snacks&munchies.jpg" style={{width:'98%', marginLeft:'5px', borderRadius:'10px', marginTop:'10px'}} />
                </div>
            </Link> */}

            <div style={{ display:'flex', justifyContent:'center', marginTop:'10px', marginBottom:'10px'}}>
                <div className="poster">
                    <Slider {...settings}>
                        {
                            extraData.data.images.map((image, index) => (
                                <img key={ index } className='poster-img' src={ image }/>
                            ))
                        }
                    </Slider>
                    
                </div>
            </div>

            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Cleaning Essentials</p>
                    <Link to='/display-products-category'
                        state={{
                            name: 'Cleaning Essentials',
                            categoryData: cleaningEssentials.data
                        }}
                        className="see-all">See all&#62;
                    </Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={cleaningEssentialsData} />
                </div>
            </div>
            
            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Home & Office</p>
                    <Link to='/display-products' state={{name:'Home & Office', productList: homeOfficeData}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={homeOfficeData} />
                </div>
            </div>
            {/* <div className="poster-school">
                <Link to='/display-products' state={{category:'notebooks,pens,markers,school-office-supply,everyday-use,files-folder', name:'Stationary'}}><img src="/school-poster.jpg" style={{width:'97%', borderRadius:'10px', marginLeft:'6px', height:'150px', objectFit:'cover', objectPosition:'top'}}></img></Link>  
            </div> */}
            <div className="horizonatal-scroll">
                <div className="name-see-all">
                    <p className="tag-name">Gadgets</p>
                    <Link to='/display-products' state={{name:'Gadgets', productList: gadgetsData}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={gadgetsData} />
                </div>
            </div>

            <RequestProductCTA />

            <BottomCart />
        </>    
    );
}



